import { r as registerInstance, h, g as getElement, c as createEvent, f as forceUpdate, H as Host } from './index-16dc7dde.js';
import { p as pesIconSizes, a as pesIconMirrorDirection } from './constants-e9ddcc22.js';
import { c as classnames } from './index-136476ff.js';
import { u as useReplatformedHMC } from './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import { s as send, F as hmcEvent, j as productSelectorVirtualPageEvent } from './send-33ade633.js';
import { i as isAnalyticsEnabled } from './helpers-71d81730.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import { t as tryParse } from './parsers-e38ff6a5.js';
import { y as isBrowser, a as isMobile, g as getData } from './utils-15ad90ec.js';
import { f as virtualPagesNestedLocations } from './analytics-765d4daf.js';
import './_commonjsHelpers-ba3f0406.js';
import './utils-913bdf8a.js';
import './isTypedArray-dfccd669.js';
import './isObject-33fa1780.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';

const bannerCss = ".banner{cursor:pointer;display:flex;flex-direction:column;border:1px solid #42b4e6;width:100%;height:100%;position:relative;overflow:hidden;text-decoration:none;background-color:#ffffff;box-sizing:border-box}.banner *,.banner *::before,.banner *::after{box-sizing:inherit}.banner::before{content:\"\";position:absolute;top:0;width:40px;height:40px;background-color:#42b4e6}:host(:not([dir=\"rtl\"])) .banner::before{left:0;border-bottom-right-radius:100%}:host([dir=\"rtl\"]) .banner::before{right:0;border-bottom-left-radius:100%}.banner__corner-icon{position:absolute;top:8px}:host(:not([dir=\"rtl\"])) .banner__corner-icon{left:8px}:host([dir=\"rtl\"]) .banner__corner-icon{right:8px}";

let Banner = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.url = '';
    this.target = '_self';
    this.icon = 'segment_retail';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    const anchorProps = this.url ? { href: this.url, target: this.target } : {};
    return (h("a", Object.assign({ class: "banner" }, anchorProps), h("pes-icon", { class: "banner__corner-icon", color: "alternative", size: pesIconSizes.MICRO }, this.icon), h("slot", null)));
  }
  get el() { return getElement(this); }
};
Banner.style = bannerCss;

const chipsListCss = ".chips-list{display:flex;justify-content:center;flex-wrap:wrap}@media screen and (min-width: 980px){.chips-list{max-width:720px}}@media screen and (min-width: 980px){.chips-list--wide{max-width:none}}.chips-list__item{margin-bottom:4px}";

const MAX_CHIPS_COUNT = 10;
let ChipsList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didChipSelect = createEvent(this, "didChipSelect", 7);
    this.handleSelect = (value) => () => {
      this.didChipSelect.emit(value);
    };
    this.isChipSelected = (value) => {
      return this.selected === value;
    };
  }
  render() {
    var _a;
    return (h("div", { class: classnames('chips-list', {
        'chips-list--wide': ((_a = this.data) === null || _a === void 0 ? void 0 : _a.length) > MAX_CHIPS_COUNT,
      }) }, this.data.map((chip) => (h("se-chip", { key: chip, class: "chips-list__item", value: chip, selected: this.isChipSelected(chip), onClick: this.handleSelect(chip) })))));
  }
};
ChipsList.style = chipsListCss;

const hmcBannerCss = ":host{box-sizing:border-box;display:block;width:100%}:host *,:host *::before,:host *::after{box-sizing:inherit}.hmc-banner{flex:1;display:flex;padding:20px 30px 10px;justify-content:center;flex-direction:column}.hmc-banner.is-short{min-height:115px;height:100%;padding:0 28px}.hmc-banner.is-square{min-height:170px}.hmc-banner.is-extended{min-height:108px}@media screen and (min-width: 980px){.hmc-banner.is-extended{flex-direction:row;padding:0 60px;justify-content:space-between;align-items:center}}.hmc-banner__text-block.is-short{text-align:center}.hmc-banner__text-block.is-square{margin-bottom:12px}@media screen and (max-width: 979px){.hmc-banner__text-block.is-extended{margin-bottom:12px}}.hmc-banner__button.is-square,.hmc-banner__button.is-extended{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;height:40px;width:100%;background-color:#42b4e6;color:#ffffff;line-height:20px;border-radius:2px;margin:0}.hmc-banner__button.is-square:hover,.hmc-banner__button.is-extended:hover{cursor:pointer;background:linear-gradient(#59bde9, #42b4e6 50%)}@media screen and (max-width: 979px){.hmc-banner__button.is-square,.hmc-banner__button.is-extended{font-size:12px}}@media screen and (min-width: 980px){.hmc-banner__button.is-square,.hmc-banner__button.is-extended{font-size:16px}}@media screen and (max-width: 979px){.hmc-banner__button.is-extended{width:192px;margin:0 auto}}@media screen and (min-width: 980px){.hmc-banner__button.is-extended{flex:0 0 192px}}.hmc-banner__heading{line-height:25px;text-align:center}.hmc-banner__heading.is-short{margin:0 0 8px;max-width:100%;color:#333333;font-size:13px;line-height:15px}.hmc-banner__heading.is-square,.hmc-banner__heading.is-extended{margin:0 0 5px;color:#626469}@media screen and (max-width: 979px){.hmc-banner__heading.is-square,.hmc-banner__heading.is-extended{font-size:14px}}@media screen and (min-width: 980px){.hmc-banner__heading.is-square,.hmc-banner__heading.is-extended{font-size:16px}}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .hmc-banner__heading.is-extended{text-align:left;margin-right:20px}:host([dir=\"rtl\"]) .hmc-banner__heading.is-extended{text-align:right;margin-left:20px}}.hmc-banner__text{text-align:center}.hmc-banner__text.is-short{display:inline;font-size:13px;line-height:15px;text-transform:capitalize}.hmc-banner:hover .hmc-banner__text.is-short{text-decoration:underline}.hmc-banner__text.is-square,.hmc-banner__text.is-extended{font-size:12px;line-height:18px;font-weight:normal;color:#626469;text-align:center}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .hmc-banner__text.is-extended{text-align:left}:host([dir=\"rtl\"]) .hmc-banner__text.is-extended{text-align:right}}.hmc-banner__text-content.is-short{background:none;color:#42b4e6;border:none;padding:0;cursor:pointer;outline:inherit;font-family:inherit;font-size:15px;line-height:20px;font-weight:normal;text-align:center}.hmc-banner__text-content.is-short:hover{text-decoration:underline}.hmc-banner__text-content.is-short:hover{text-decoration:none}.hmc-banner__text-arrow-icon.is-short{display:inline-flex;align-items:center;vertical-align:middle;position:relative}:host(:not([dir=\"rtl\"])) .hmc-banner__text-arrow-icon.is-short{left:3px}:host([dir=\"rtl\"]) .hmc-banner__text-arrow-icon.is-short{right:3px;transform:scaleX(-1)}.banner-container--prerender{min-height:110px}";

const SQUARE_VARIANT_MAX_WIDTH = 300;
let HmcBanner = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pimId = null;
    this.parentCategoryId = null;
    this.hasQuestionnaire = false;
    this.variant = 'short';
    this.hideHMCBanner = false;
    this.isPBS = false;
    this.handleClick = (e) => {
      if (this.hasQuestionnaire) {
        e.preventDefault();
        const widget = document.createElement('pes-hmc-widget');
        widget.categoryId = this.sourceId;
        widget.questionnaireUrl = this.questionnaireUrl;
        widget.rangeTooltipUrl = this.rangeTooltipUrl;
        widget.selectorConfigUrl = this.selectorConfigUrl;
        widget.isPBS = this.isPBS;
        document.body.appendChild(widget);
        if (isAnalyticsEnabled()) {
          send(hmcEvent, this.getAnalyticsData());
        }
      }
    };
    this.buildClassName = (element) => {
      const block = 'hmc-banner';
      const fullClassName = element ? `${block}__${element}` : block;
      const variantClassName = `is-${this.variant}`;
      return classnames(fullClassName, variantClassName);
    };
    this.getAnalyticsData = () => {
      const pageCategoryId = !useReplatformedHMC
        ? this.sourceId.match(/\d+/).toString()
        : this.parentCategoryId;
      return { pageCategoryId: this.parentCategoryId || pageCategoryId };
    };
    this.renderText = () => {
      var _a, _b;
      return this.variant === 'short' ? (h("span", { class: this.buildClassName('text-content') }, h("span", { class: this.buildClassName('text'), innerHTML: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcStartMessage }), h("pes-icon", { class: this.buildClassName('text-arrow-icon'), size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"))) : (h("div", { class: this.buildClassName('text') }, (_b = this.labels) === null || _b === void 0 ? void 0 : _b.hmcStartMessage));
    };
    this.getVariant = () => {
      var _a;
      if (!((_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcStartBtn)) {
        return 'short';
      }
      const hostWidth = this.host.getBoundingClientRect().width;
      return hostWidth <= SQUARE_VARIANT_MAX_WIDTH ? 'square' : 'extended';
    };
    this.host.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    this.labels = (_a = tryParse(this._labels)) !== null && _a !== void 0 ? _a : this.labels;
    this.labels = (_b = tryParse(this._labels)) !== null && _b !== void 0 ? _b : this.labels;
    this.categoryName = (_c = tryParse(this._categoryName)) !== null && _c !== void 0 ? _c : this.categoryName;
    const pimId = (_d = tryParse(this._pimId)) !== null && _d !== void 0 ? _d : this.pimId;
    const sourceId = (_e = tryParse(this._sourceId)) !== null && _e !== void 0 ? _e : this.sourceId;
    this.sourceId = pimId === null ? sourceId : pimId;
    this.categoryProductConfiguratorUrl = (_f = tryParse(this._categoryProductConfiguratorUrl)) !== null && _f !== void 0 ? _f : this.categoryProductConfiguratorUrl;
    this.isExternalProductConfiguratorUrl = (_g = tryParse(this._isExternalProductConfiguratorUrl)) !== null && _g !== void 0 ? _g : this.isExternalProductConfiguratorUrl;
    this.hasQuestionnaire = (_h = tryParse(this._hasQuestionnaire)) !== null && _h !== void 0 ? _h : this.hasQuestionnaire;
    this.questionnaireUrl = (_j = tryParse(this._questionnaireUrl)) !== null && _j !== void 0 ? _j : this.questionnaireUrl;
    this.rangeTooltipUrl = (_k = tryParse(this._rangeTooltipUrl)) !== null && _k !== void 0 ? _k : this.rangeTooltipUrl;
    this.selectorConfigUrl = (_l = tryParse(this._selectorConfigUrl)) !== null && _l !== void 0 ? _l : this.selectorConfigUrl;
    this.variant = (_m = tryParse(this._variant)) !== null && _m !== void 0 ? _m : this.variant;
    this.parentCategoryId = (_o = tryParse(this._parentCategoryId)) !== null && _o !== void 0 ? _o : this.parentCategoryId;
    this.hideHMCBanner = (_p = tryParse(this._hideHMCBanner)) !== null && _p !== void 0 ? _p : this.hideHMCBanner;
    this.hmcBanner = (_q = tryParse(this._hmcBanner)) !== null && _q !== void 0 ? _q : this.hmcBanner;
  }
  getTargetForUrl() {
    return this.isExternalProductConfiguratorUrl ? '_blank' : '_self';
  }
  componentDidLoad() {
    this.variant = this.getVariant();
  }
  isHMCEnabled() {
    return !this.hideHMCBanner && !isEmpty_1(this.labels);
  }
  render() {
    var _a, _b, _c, _d;
    const heading = this.variant !== 'short' && this.categoryName
      ? (_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcHeader.replace('#CategoryName#', this.categoryName)
      : (_b = this.labels) === null || _b === void 0 ? void 0 : _b.hmcHeader;
    const urlProps = !this.hasQuestionnaire && this.categoryProductConfiguratorUrl
      ? {
        url: this.categoryProductConfiguratorUrl,
        target: this.getTargetForUrl(),
      }
      : {};
    if (!this.labels)
      return null;
    return (h("div", { class: classnames({
        'subcategories__banner-container--prerender': this.isHMCEnabled(),
      }) }, this.isHMCEnabled() && isBrowser() ? (h("pes-banner", Object.assign({}, urlProps, { icon: "action_search_stroke", onClick: this.handleClick }), h("div", { class: this.buildClassName() }, h("div", { class: this.buildClassName('text-block') }, h("h2", { class: this.buildClassName('heading'), innerHTML: heading }), this.renderText()), ((_c = this.labels) === null || _c === void 0 ? void 0 : _c.hmcStartBtn) && (h("button", { type: "button", class: this.buildClassName('button') }, (_d = this.labels) === null || _d === void 0 ? void 0 : _d.hmcStartBtn))))) : null));
  }
  get host() { return getElement(this); }
};
HmcBanner.style = hmcBannerCss;

const hmcCardCss = ":host{display:block}.hmc-card{position:relative;display:flex;font-size:14px;line-height:20px;color:#626469}.hmc-card .highlight-naming{font-weight:400}.hmc-card .highlight-naming .accent{font-weight:700}@media screen and (max-width: 979px){.hmc-card{padding:16px}}@media screen and (min-width: 980px){.hmc-card{padding:24px 24px 56px}}.hmc-card--best-match{border:1px solid #3dcd58}@media screen and (min-width: 980px){.hmc-card--best-match{padding:24px}}.hmc-card__img-link-wrapper{cursor:pointer;display:block}@media screen and (max-width: 979px){.hmc-card__img-link-wrapper{height:60px;width:60px}:host(:not([dir=\"rtl\"])) .hmc-card__img-link-wrapper{margin-right:16px}:host([dir=\"rtl\"]) .hmc-card__img-link-wrapper{margin-left:16px}}@media screen and (min-width: 980px){.hmc-card__img-link-wrapper{height:130px}:host(:not([dir=\"rtl\"])) .hmc-card__img-link-wrapper{margin-right:24px}:host([dir=\"rtl\"]) .hmc-card__img-link-wrapper{margin-left:24px}}.hmc-card__img-link-wrapper:hover{cursor:pointer}@media screen and (max-width: 979px){.hmc-card__img{max-height:60px;min-width:60px;max-width:60px}}@media screen and (min-width: 980px){.hmc-card__img{min-width:130px;max-width:130px;max-height:130px}}.hmc-card__text-content{display:flex;flex-direction:column;width:100%}@media screen and (max-width: 979px){.hmc-card__text-content{max-width:calc(100% - 76px)}}@media screen and (min-width: 980px){.hmc-card__text-content{max-width:calc(100% - 154px)}}.hmc-card__text-content-link-wrapper{cursor:pointer;display:flex;flex-direction:column;color:#626469;text-decoration:none}.hmc-card__badge{display:none;margin-bottom:12px}.hmc-card--best-match .hmc-card__badge{display:flex}.hmc-card__title{font-size:16px;line-height:24px;color:#333333;margin:0 0 8px;padding:0;height:100%}.hmc-card__title .highlight-naming{font-weight:400}.hmc-card__title .highlight-naming .accent{font-weight:700}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .hmc-card__title{padding-right:50px}:host([dir=\"rtl\"]) .hmc-card__title{padding-left:50px}}.hmc-card__text-content-link-wrapper:hover .hmc-card__title,.hmc-card__img-link-wrapper:hover+.hmc-card__text-content .hmc-card__title{color:#70e07c}.hmc-card__description{overflow:hidden}.hmc-card__master-range-info{margin-top:8px}.hmc-card__text-content-link-wrapper:hover .hmc-card__view-products,.hmc-card__img-link-wrapper:hover+.hmc-card__text-content .hmc-card__view-products{text-decoration:underline}@media screen and (max-width: 979px){.hmc-card__information{display:none}}@media screen and (min-width: 980px){.hmc-card__information{position:absolute;top:24px;width:18px;height:18px;cursor:pointer}:host(:not([dir=\"rtl\"])) .hmc-card__information{right:24px}:host([dir=\"rtl\"]) .hmc-card__information{left:24px}}.hmc-card__tooltip-text{font-size:12px;width:auto;overflow:hidden}.hmc-card__tooltip-title{font-size:14px;line-height:20px;margin-bottom:10px;text-transform:capitalize;font-weight:bold}";

const DESCRIPTION_MAX_HEIGHT = '60px';
const TOOLTIP_MAX_HEIGHT = '298px';
let HmcCard = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didCloseDialog = createEvent(this, "didCloseDialog", 7);
    this.rangeTooltipInfo = {};
    this.page = 'all-products';
    this.selectorConfig = {};
    this.isPBS = false;
    this.linkHovered = false;
    this.tooltipContent = this.getTooltipContent();
    this.handleTooltipActivate = () => {
      var _a;
      (_a = this.tooltipContentRef) === null || _a === void 0 ? void 0 : _a.triggerUpdate();
    };
    this.getRangeDescription = () => {
      const { description, longDescription } = this.range;
      return [description, longDescription].filter(Boolean).join(' ');
    };
    this.handleLinkMouseOver = () => {
      this.linkHovered = true;
    };
    this.handleLinkMouseOut = () => {
      this.linkHovered = false;
    };
    this.handleLinkClick = () => {
      this.didCloseDialog.emit();
    };
    this.host.dir = document.documentElement.dir || 'auto';
  }
  handleChangeRangeTooltipInfo() {
    this.tooltipContent = this.getTooltipContent();
  }
  getTooltipContent() {
    const rangeId = useReplatformedHMC() ? this.range.rangeId : this.range.repositoryId;
    if (this.rangeTooltipInfo && rangeId in this.rangeTooltipInfo) {
      const { presentation1, presentation2 } = this.rangeTooltipInfo[rangeId];
      return [presentation1, presentation2].filter(Boolean).join(' ');
    }
  }
  componentDidLoad() {
    forceUpdate(this.host);
  }
  render() {
    var _a, _b, _c, _d, _e;
    return (h("div", { class: classnames('hmc-card', {
        'hmc-card--best-match': this.isBestMatch,
      }) }, h("pes-router-link", { page: this.page, pageId: useReplatformedHMC() ? this.range.rangeId : this.range.sourceId, url: !this.isPBS ? this.range.selfRef : null, target: "_self", class: "hmc-card__img-link-wrapper" }, h("a", { href: "#", onMouseOver: this.handleLinkMouseOver, onMouseOut: this.handleLinkMouseOut }, h("img", { class: "hmc-card__img", src: this.range.imageUrl, alt: "" }))), h("div", { class: "hmc-card__text-content" }, h("pes-router-link", { page: this.page, pageId: useReplatformedHMC() ? this.range.rangeId : this.range.sourceId, url: !this.isPBS ? this.range.selfRef : null, target: "_self" }, h("a", { class: "hmc-card__text-content-link-wrapper", href: "#", onClick: this.handleLinkClick, onMouseOver: this.handleLinkMouseOver, onMouseOut: this.handleLinkMouseOut }, h("pes-badge", { class: "hmc-card__badge", label: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.bestMatchLabel }), h("h3", { class: "hmc-card__title", innerHTML: this.range.name }), h("pes-ellipsis", { class: "hmc-card__description", maxHeight: DESCRIPTION_MAX_HEIGHT, content: this.getRangeDescription() }), this.range.masterRangeInfo && (h("div", { class: "hmc-card__master-range-info", innerHTML: this.range.masterRangeInfo })), h("pes-hmc-link", { class: "hmc-card__view-products", active: this.linkHovered }, this.range.hasProducts
      ? (_b = this.labels) === null || _b === void 0 ? void 0 : _b.hmcViewProducts
      : (_c = this.labels) === null || _c === void 0 ? void 0 : _c.hmcViewDetails))), h("pes-hmc-product-selector", { functionalIds: useReplatformedHMC() ? this.range.productConfiguratorUrl : this.range.functionalIds, selectorConfig: this.selectorConfig, legacyConfiguratorUrl: this.range.legacyConfiguratorUrl, useProductSelectorLabel: (_d = this.labels) === null || _d === void 0 ? void 0 : _d.useProductSelector, selectorHeaderLabel: this.range.name })), this.tooltipContent && (h("pdp-icon-tooltip", { class: "hmc-card__information", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top", onDidOpen: this.handleTooltipActivate }, h("div", { class: "hmc-card__tooltip" }, h("div", { class: "hmc-card__tooltip-title" }, (_e = this.labels) === null || _e === void 0 ? void 0 : _e.featuresLabel), h("pes-ellipsis", { ref: (el) => (this.tooltipContentRef = el), class: "hmc-card__tooltip-text", maxHeight: TOOLTIP_MAX_HEIGHT, content: this.tooltipContent }))))));
  }
  get host() { return getElement(this); }
  static get watchers() { return {
    "rangeTooltipInfo": ["handleChangeRangeTooltipInfo"]
  }; }
};
HmcCard.style = hmcCardCss;

const hmcLinkCss = ":host{background:none;color:#42b4e6;border:none;padding:0;cursor:pointer;outline:inherit;font-family:inherit;text-decoration:none !important;display:inline-flex;align-items:center;font-size:inherit;line-height:inherit;font-weight:normal;margin-top:0;padding-top:8px}:host:hover{text-decoration:underline}@media screen and (max-width: 979px){:host{max-width:100%}}.hmc-link__text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;text-transform:capitalize}:host([active]) .hmc-link__text,:host(:hover) .hmc-link__text{text-decoration:underline}.hmc-link__icon{text-decoration:none !important;flex-shrink:0;overflow:hidden;position:relative}:host(:not([dir=\"rtl\"])) .hmc-link__icon{left:2px}:host([dir=\"rtl\"]) .hmc-link__icon{right:2px;transform:scaleX(-1)}";

let HmcLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.active = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("span", { class: "hmc-link__text" }, h("slot", null)), h("pes-icon", { size: pesIconSizes.NANO, class: "hmc-link__icon", mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")));
  }
  get el() { return getElement(this); }
};
HmcLink.style = hmcLinkCss;

const hmcModalCss = ".hmc-modal__content{display:block}@media screen and (max-width: 979px){.hmc-modal__content{margin:0 -8px;max-width:100vw}}@media screen and (min-width: 980px){.hmc-modal__content{height:80vh;padding:0 20px;max-width:1040px}}";

let HmcModal = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isOpened = false;
    this.isPBS = false;
    this.isMobile = isMobile();
    this.resizeWindow = () => {
      this.isMobile = isMobile();
    };
  }
  connectedCallback() {
    window.addEventListener('resize', this.resizeWindow);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeWindow);
  }
  render() {
    var _a, _b;
    return (h("se-dialog", { open: this.isOpened, size: this.isMobile ? 'fill' : 'xlarge', pageScroll: false }, h("se-dialog-header", { closeIcon: true }, (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.helpMeChooseLabel), h("se-dialog-content", { isLastChild: false }, h("div", { class: "hmc-modal__content" }, h("se-loading", { loading: isEmpty_1(this.data) && this.isOpened }), !isEmpty_1(this.data) && (h("pes-widget-body", { data: this.data, isPBS: this.isPBS, rangeTooltipInfo: this.rangeTooltipInfo, selectorConfig: this.selectorConfig, isMobile: this.isMobile }))))));
  }
};
HmcModal.style = hmcModalCss;

let ProductSelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didOpenProductSelector = createEvent(this, "didOpenProductSelector", 7);
    this.handleOpenProductSelector = (selector, config) => (_) => {
      this.didOpenProductSelector.emit();
      if (config.type === 'sc') {
        const host = document.createElement('pdp-sc-selector-modal');
        const frame = document.createElement('div');
        frame.id = 'widgetFrame';
        host.headerLabel = config.scLabel || this.selectorHeaderLabel || 'Select your product';
        host.appendChild(frame);
        host.open = true;
        host.addEventListener('didClose', () => {
          document.body.removeChild(host);
        });
        document.body.appendChild(host);
      }
      selector.open(config);
      send(productSelectorVirtualPageEvent, {
        location: virtualPagesNestedLocations.HELP_ME_CHOOSE,
      });
    };
    this.openConfigurator = () => {
      window.open(this.legacyConfiguratorUrl, '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=1070, height=700');
    };
    this.renderProductSelector = () => {
      const config = Object.assign(Object.assign({}, this.selectorConfig), { scFunctionalIds: this.functionalIds });
      return (h("pes-product-selector", { config: config, renderFunction: (selector) => (h("pes-hmc-link", { onClick: this.handleOpenProductSelector(selector, config) }, this.useProductSelectorLabel)) }));
    };
  }
  render() {
    if ((!this.functionalIds || isEmpty_1(this.selectorConfig)) && !this.legacyConfiguratorUrl) {
      return;
    }
    if (this.functionalIds) {
      return this.renderProductSelector();
    }
    return (h("pes-hmc-link", { onClick: this.openConfigurator }, this.useProductSelectorLabel));
  }
};

let HmcWidget = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isPBS = false;
    this.isOpened = false;
    this.closeModal = () => {
      this.data = null;
      this.rangeTooltipInfo = null;
      this.isOpened = false;
    };
    this.fetchQuestionnaire = (id) => {
      if (!id) {
        return;
      }
      const rest = this.questionnaireUrl.replace(':id', id);
      getData(false, rest).then((res) => {
        if (!isEmpty_1(res)) {
          this.data = res;
        }
      });
    };
    this.fetchSelectorConfig = () => {
      getData(false, this.selectorConfigUrl).then((res) => {
        if (!isEmpty_1(res)) {
          this.selectorConfig = res;
        }
      });
    };
    this.createRangeTooltipInfoMap = (presentations) => presentations.reduce((obj, range) => {
      if (!obj[range.rangeId]) {
        return Object.assign(Object.assign({}, obj), { [range.rangeId]: range });
      }
      return Object.assign({}, obj);
    }, {});
    this.fetchRangeTooltipInfo = (rangeIds) => {
      if (!rangeIds) {
        return;
      }
      if (!isEmpty_1(this.rangeTooltipInfo)
        && rangeIds.every((id) => Object.keys(this.rangeTooltipInfo).includes(id))) {
        return this.rangeTooltipInfo;
      }
      const rest = this.rangeTooltipUrl.replace(':ids', rangeIds.join());
      getData(false, rest).then((res) => {
        if (!isEmpty_1(res) && !isEmpty_1(res.presentations)) {
          this.rangeTooltipInfo = this.createRangeTooltipInfoMap(res.presentations);
        }
      });
    };
  }
  handleRangesDisplay(e) {
    const rangesIds = e.detail;
    this.fetchRangeTooltipInfo(rangesIds);
  }
  handleCloseDialog() {
    this.closeModal();
  }
  handleOpenProductSelector() {
    this.closeModal();
  }
  componentWillLoad() {
    this.fetchQuestionnaire(this.categoryId);
    this.fetchSelectorConfig();
    this.isOpened = true;
  }
  render() {
    return (h("pes-hmc-modal", { data: this.data, isPBS: this.isPBS, isOpened: this.isOpened, rangeTooltipInfo: this.rangeTooltipInfo, selectorConfig: this.selectorConfig }));
  }
};

const widgetAnswersCss = "@media screen and (max-width: 979px){:host{display:block;width:100%;padding-bottom:96px}}";

let WidgetAnswers = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return h("pes-chips-list", { data: this.answers, selected: this.selectedAnswer });
  }
};
WidgetAnswers.style = widgetAnswersCss;

const widgetBackButtonCss = ".widget-back-button{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;font-size:14px;line-height:20px;color:#42b4e6}@media screen and (min-width: 980px){.widget-back-button{padding:8px 0 0}}:host(:not([dir=\"rtl\"])) .widget-back-button__icon{margin-right:-3px}:host([dir=\"rtl\"]) .widget-back-button__icon{margin-left:-3px}.widget-back-button__icon,.widget-back-button__text{vertical-align:middle}";

let WidgetBackButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didBackButtonClick = createEvent(this, "didBackButtonClick", 7);
    this.handleButtonClick = () => {
      this.didBackButtonClick.emit();
    };
  }
  render() {
    return (h("button", { class: "widget-back-button", onClick: this.handleButtonClick }, h("pes-icon", { size: pesIconSizes.MEDIUM, class: "widget-back-button__icon" }, "arrow2_left"), h("span", { class: "widget-back-button__text" }, this.backLabel)));
  }
};
WidgetBackButton.style = widgetBackButtonCss;

const getQuestionnaireItemByPath = (childItems, path, index = 0) => {
  var _a;
  const lastIndex = path.length - 1;
  let questionnaireItem = childItems.find((item) => item.answer === path[index]);
  if (!!((_a = questionnaireItem === null || questionnaireItem === void 0 ? void 0 : questionnaireItem.childItems) === null || _a === void 0 ? void 0 : _a.length) && lastIndex !== index) {
    questionnaireItem = getQuestionnaireItemByPath(questionnaireItem.childItems, path, index + 1);
  }
  return questionnaireItem;
};
const generatePath = (selectedItem, selectedChild, isLastSelected) => {
  var _a;
  if (!((_a = selectedItem.path) === null || _a === void 0 ? void 0 : _a.length)) {
    return [selectedChild.answer];
  }
  const { path } = selectedItem;
  const pathToParent = path.slice(0, path.length - 1);
  return isLastSelected && (pathToParent === null || pathToParent === void 0 ? void 0 : pathToParent.length) !== 0
    ? [...pathToParent, selectedChild.answer]
    : [...path, selectedChild.answer];
};
function isSelectedItem(item) {
  return 'answer' in item && 'question' in item && 'childItems' in item && 'rangeIds' in item;
}
const createSelectedItem = (item, path) => ({
  answer: item.answer,
  childItems: item.childItems,
  question: item.question,
  rangeIds: isSelectedItem(item) ? item.rangeIds : [],
  path,
});

const widgetBodyCss = ".widget-body{display:flex;flex-direction:column;position:relative;height:100%}.widget-body__question{display:flex;justify-content:center;align-items:center;flex-direction:column;padding-bottom:16px;width:100%}@media screen and (min-width: 980px){.widget-body__question{border-bottom:1px solid #e7e6e6}}.widget-body__question--first{border:none}@media screen and (min-width: 980px){.widget-body__question--first{height:100%}}.widget-body__back-button{visibility:hidden}.widget-body__back-button--visible{visibility:visible}";

let WidgetBody = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didDisplayRanges = createEvent(this, "didDisplayRanges", 7);
    this.isPBS = false;
    this.isLastSelected = false;
    this.breadcrumbs = [];
  }
  onItemSelect(event) {
    var _a, _b, _c, _d;
    const value = event.detail;
    const selectedChild = this.isLastSelected
      ? (_b = (_a = this.previousSelected) === null || _a === void 0 ? void 0 : _a.childItems) === null || _b === void 0 ? void 0 : _b.find((item) => item.answer === value)
      : (_d = (_c = this.currentSelected) === null || _c === void 0 ? void 0 : _c.childItems) === null || _d === void 0 ? void 0 : _d.find((item) => item.answer === value);
    if (selectedChild) {
      const path = generatePath(this.currentSelected, selectedChild, this.isLastSelected);
      this.currentSelected = createSelectedItem(selectedChild, path);
    }
  }
  onBreadcrumbClicked(e) {
    const { path } = e.detail;
    if (path === null || path === void 0 ? void 0 : path.length) {
      this.currentSelected = this.getParentItemByPath(path);
    }
  }
  onBackButtonClick() {
    const { path } = this.currentSelected;
    if (path === null || path === void 0 ? void 0 : path.length) {
      this.currentSelected = this.getParentItemByPath(path);
    }
  }
  onSelectedChange() {
    this.setIsLastSelected();
    this.getPreviousSelected();
    this.getCurrentQuestion();
    this.getCurrentAnswers();
    this.filterRanges();
    this.createBreadcrumbs();
  }
  onRangesDisplay() {
    var _a;
    if ((_a = this.ranges) === null || _a === void 0 ? void 0 : _a.length) {
      const rangesIds = this.ranges.map((range) => (useReplatformedHMC() ? range.rangeId : range.repositoryId));
      this.didDisplayRanges.emit(rangesIds);
    }
  }
  getParentItemByPath(path) {
    const pathToParent = path.slice(0, path.length - 1);
    const questionnaireItem = getQuestionnaireItemByPath(this.data.questionnaire.questionnaireItem.childItems, pathToParent);
    if (questionnaireItem) {
      return createSelectedItem(questionnaireItem, pathToParent);
    }
    return createSelectedItem(this.data.questionnaire.questionnaireItem);
  }
  getCurrentAnswers() {
    this.answers = this.isLastSelected
      ? this.previousSelected.childItems.map((i) => i.answer)
      : this.currentSelected.childItems.map((i) => i.answer);
  }
  getCurrentQuestion() {
    this.question = this.isLastSelected
      ? this.previousSelected.question
      : this.currentSelected.question;
  }
  getPreviousSelected() {
    const { path } = this.currentSelected;
    if (path === null || path === void 0 ? void 0 : path.length) {
      this.previousSelected = this.getParentItemByPath(path);
    }
  }
  filterRanges() {
    var _a, _b;
    const rangeIds = (_a = this.currentSelected) === null || _a === void 0 ? void 0 : _a.rangeIds;
    const filteredRanges = (_b = this.data.ranges) === null || _b === void 0 ? void 0 : _b.filter((range) => {
      const rangeId = useReplatformedHMC() ? range.rangeId : range.repositoryId;
      return rangeIds === null || rangeIds === void 0 ? void 0 : rangeIds.includes(rangeId);
    });
    this.ranges = filteredRanges === null || filteredRanges === void 0 ? void 0 : filteredRanges.sort((range1, range2) => {
      const rangeId1 = useReplatformedHMC() ? range1.rangeId : range1.repositoryId;
      const rangeId2 = useReplatformedHMC() ? range2.rangeId : range2.repositoryId;
      return rangeIds.indexOf(rangeId1) - rangeIds.indexOf(rangeId2);
    });
  }
  setIsLastSelected() {
    this.isLastSelected = !this.currentSelected.childItems.length;
  }
  createBreadcrumbs() {
    var _a, _b, _c;
    if ((_a = this.currentSelected) === null || _a === void 0 ? void 0 : _a.path) {
      let newPath;
      this.breadcrumbs = (_c = (_b = this.currentSelected) === null || _b === void 0 ? void 0 : _b.path) === null || _c === void 0 ? void 0 : _c.map((selected) => {
        newPath = newPath ? [...newPath, selected] : [selected];
        return {
          name: selected,
          path: newPath,
        };
      });
    }
    else {
      this.breadcrumbs = [];
    }
  }
  componentWillLoad() {
    const { questionnaireItem } = this.data.questionnaire;
    this.currentSelected = createSelectedItem(questionnaireItem);
  }
  render() {
    var _a, _b;
    const isFirstQuestion = !this.currentSelected.path;
    return (h("div", { class: "widget-body" }, this.isMobile ? (h("pes-widget-back-button", { backLabel: (_a = this.data.labels) === null || _a === void 0 ? void 0 : _a.backLabel, class: classnames('widget-body__back-button', {
        'widget-body__back-button--visible': this.currentSelected.path,
      }) })) : (h("pes-widget-breadcrumbs", { breadcrumbs: this.breadcrumbs, isLastSelected: this.isLastSelected })), h("div", { class: classnames('widget-body__question', {
        'widget-body__question--first': isFirstQuestion,
      }) }, h("pes-widget-header", { isLarge: isFirstQuestion }, this.question), h("pes-widget-answers", { answers: this.answers, selectedAnswer: this.currentSelected.answer })), ((_b = this.ranges) === null || _b === void 0 ? void 0 : _b.length) !== 0 && (h("pes-widget-ranges", { ranges: this.ranges, rangeTooltipInfo: this.rangeTooltipInfo, isMobile: this.isMobile, isPBS: this.isPBS, isLastSelected: this.isLastSelected, labels: this.data.labels, selectorConfig: this.selectorConfig }))));
  }
  static get watchers() { return {
    "currentSelected": ["onSelectedChange"],
    "ranges": ["onRangesDisplay"]
  }; }
};
WidgetBody.style = widgetBodyCss;

const widgetBreadcrumbsCss = ".widget-breadcrumbs{margin:0;padding:0;list-style:none;box-sizing:border-box;display:flex;flex-wrap:wrap;font-weight:400}.widget-breadcrumbs *,.widget-breadcrumbs *::before,.widget-breadcrumbs *::after{box-sizing:inherit}.widget-breadcrumbs__item{line-height:1;display:flex;align-items:center}.widget-breadcrumbs__button{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;display:inline-block;font-size:14px;line-height:18px;color:#333333;text-decoration:none}.widget-breadcrumbs__button--last{color:#9fa0a4}.widget-breadcrumbs__icon{margin:0}:host([dir=\"rtl\"]) .widget-breadcrumbs__icon{transform:scaleX(-1)}";

let WidgetBreadcrumbs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didBreadcrumbClick = createEvent(this, "didBreadcrumbClick", 7);
    this.breadcrumbs = [];
    this.isLastSelected = false;
    this.handleBreadcrumbClick = (value) => () => {
      this.didBreadcrumbClick.emit(value);
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("ul", { class: "widget-breadcrumbs" }, this.breadcrumbs.map((item, index) => {
      const lastIndex = this.breadcrumbs.length - 1;
      const isLast = this.isLastSelected && index === lastIndex;
      return (h("li", { class: "widget-breadcrumbs__item", key: item.name }, h("button", { class: classnames('widget-breadcrumbs__button', {
          'widget-breadcrumbs__button--last': isLast,
        }), onClick: this.handleBreadcrumbClick(item) }, h("span", { innerHTML: item.name })), !isLast && h("pes-icon", { class: "widget-breadcrumbs__icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")));
    })));
  }
  get el() { return getElement(this); }
};
WidgetBreadcrumbs.style = widgetBreadcrumbsCss;

const widgetHeaderCss = ".widget-header{font-size:18px;color:#333333;font-weight:bold;margin:20px 0 12px;text-align:center}@media screen and (min-width: 980px){.widget-header{line-height:30px;font-size:22px}}@media screen and (min-width: 980px){.widget-header--large{line-height:40px;font-size:30px;font-weight:normal;margin-top:0}}";

let WidgetHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isLarge = false;
  }
  render() {
    return (h("h1", { class: classnames('widget-header', {
        'widget-header--large': this.isLarge,
      }) }, h("slot", null)));
  }
};
WidgetHeader.style = widgetHeaderCss;

const widgetRangesCss = "@media screen and (min-width: 980px){:host{flex:1;overflow:auto;scrollbar-width:thin !important}:host::-webkit-scrollbar{width:6px;height:6px}:host::-webkit-scrollbar-thumb{background:#cbcbcb;border-radius:3px}:host::-webkit-scrollbar-track{background:#ffffff;border-radius:3px}:host{scrollbar-face-color:#cbcbcb;scrollbar-track-color:#ffffff}}@media screen and (max-width: 979px){.widget-ranges{position:absolute;height:100%;width:100%;top:0;bottom:0;left:0;right:0;background-color:#ffffff}}.widget-ranges__results{margin:20px 0;font-size:14px;color:#333333;line-height:20px}.widget-ranges__results-total{font-weight:bold}.widget-ranges__button-wrapper{position:fixed;bottom:0;left:0;right:0;background-color:#ffffff}.widget-ranges__button-wrapper::before{content:\"\";position:absolute;height:48px;width:100%;display:block;bottom:68px}:host(:not([dir=\"rtl\"])) .widget-ranges__button-wrapper::before{background:linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%)}:host([dir=\"rtl\"]) .widget-ranges__button-wrapper::before{background:linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%)}.widget-ranges__button{margin:0 8px 20px}.widget-ranges__cards{display:flex;flex-wrap:wrap;width:100%}.widget-ranges__card{width:100%}@media screen and (min-width: 980px){.widget-ranges__card{width:50%}}.widget-ranges__shadow{position:absolute;height:48px;width:100%;bottom:0}:host(:not([dir=\"rtl\"])) .widget-ranges__shadow{background:linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%);right:6px}:host([dir=\"rtl\"]) .widget-ranges__shadow{background:linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 67%, white 100%);left:6px}";

const RANGES_COUNT_PER_ROW = 2;
const NUMBER_OF_RANGES_PLACEHOLDER = '#number of ranges#';
let WidgetRanges = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isPBS = false;
    this.isResultShown = false;
    this.onButtonClick = () => {
      this.isResultShown = true;
    };
  }
  onBackButtonClick() {
    this.isResultShown = false;
  }
  render() {
    var _a, _b, _c, _d, _e;
    const rangesTotalCount = this.ranges.length;
    if (this.isMobile && !this.isResultShown && !this.isLastSelected) {
      return (h("div", { class: "widget-ranges__button-wrapper" }, h("se-button", { color: "secondary", size: "large", class: "widget-ranges__button", block: true, onClick: this.onButtonClick }, (_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcMessageWeFoundResults.replace(NUMBER_OF_RANGES_PLACEHOLDER, String(rangesTotalCount)))));
    }
    const { hmcViewProducts, useProductSelector, featuresLabel, bestMatchLabel, hmcViewDetails } = this.labels || {};
    const cardLabels = {
      hmcViewProducts,
      hmcViewDetails,
      useProductSelector,
      featuresLabel,
      bestMatchLabel,
    };
    return (h("div", { class: "widget-ranges" }, this.isMobile ? ([
      h("pes-widget-back-button", { backLabel: (_b = this.labels) === null || _b === void 0 ? void 0 : _b.backLabel }),
      h("pes-widget-header", null, (_c = this.labels) === null || _c === void 0 ? void 0 : _c.hmcMessageWeFoundResults.replace(NUMBER_OF_RANGES_PLACEHOLDER, String(rangesTotalCount))),
    ]) : (h("p", { class: "widget-ranges__results" }, (_e = (_d = this.labels) === null || _d === void 0 ? void 0 : _d.hmcMessageWeFoundResultsDesktop) === null || _e === void 0 ? void 0 :
      _e.replace(NUMBER_OF_RANGES_PLACEHOLDER, ''), h("span", { class: "widget-ranges__results-total" }, rangesTotalCount))), h("div", { class: "widget-ranges__cards" }, this.ranges.map((range, index) => (h("pes-hmc-card", { key: useReplatformedHMC() ? range.rangeId : range.repositoryId, class: "widget-ranges__card", range: range, page: "range", isPBS: this.isPBS, isBestMatch: this.isLastSelected && index === 0, rangeTooltipInfo: this.rangeTooltipInfo, labels: cardLabels, selectorConfig: this.selectorConfig })))), !this.isMobile && this.ranges.length > RANGES_COUNT_PER_ROW && (h("div", { class: "widget-ranges__shadow" }))));
  }
};
WidgetRanges.style = widgetRangesCss;

export { Banner as pes_banner, ChipsList as pes_chips_list, HmcBanner as pes_hmc_banner, HmcCard as pes_hmc_card, HmcLink as pes_hmc_link, HmcModal as pes_hmc_modal, ProductSelector as pes_hmc_product_selector, HmcWidget as pes_hmc_widget, WidgetAnswers as pes_widget_answers, WidgetBackButton as pes_widget_back_button, WidgetBody as pes_widget_body, WidgetBreadcrumbs as pes_widget_breadcrumbs, WidgetHeader as pes_widget_header, WidgetRanges as pes_widget_ranges };
